module.exports = __webpack_public_path__ + "img/img5.caa474d1.png";